export default Object.freeze({
    PRE_AUTH_TOKEN_KEY: 'ls_preauth_token',
    AUTO_LOGIN_WITH_REDIRECT_KEY: 'auto_login_with_redirect',
});
